import BaseStore from '@src/utils/store/base-store';
import { useEffect } from 'react';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import useFunLinkPageData from '@src/utils/use-fun-link-page-data.js';
import { observable } from 'mobx';

class GameplayStore extends BaseStore {
  @observable slidesData = [];
  swiperStore = new BaseSwiperStore({
    swiperOptions: {
      spaceBetween: 0,
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: false
      // },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      allowTouchMove: false
    }
  });

  use() {
    super.use();
    const pageData = useFunLinkPageData();

    useEffect(
      () => {
        if (pageData) {
          this.slidesData = pageData.gameplay_list || [];
        }
      },
      [pageData]
    );
  }
}

export default GameplayStore;
